
import { Component, Vue, Prop } from 'vue-property-decorator';
import { RecipePreview } from '@/models/Recipe';

@Component({
    name: 'RecipeCard',
    components: {
    },
})
export default class RecipeCard extends Vue {
    @Prop({ type: Object, required: true }) recipe: RecipePreview;
}
